import moment, { fn, utc, Moment } from 'moment';

import { BusinessDayStartHour, Commodity } from '@models/types/all';

export class MomentJsUtils {
  static setupPluginNativeUTC() {
    (fn as any).nativeUTC = function () {
      const self = this as Moment;
      return utc([self.year(), self.month(), self.date(), self.hour(), self.minutes(), 0]).subtract(self.isDST() ? 2 : 1, 'hours');
    };
  }

  static setupPluginStartOfCommodity() {
    (fn as any).startOfCommodity = function (commodity: Commodity, unitOfTime: moment.unitOfTime.StartOf) {
      const self = this as Moment;

      const value = self.startOf(unitOfTime);
      if (commodity === Commodity.gas) {
        value.hour(commodity === Commodity.gas ? BusinessDayStartHour.gas : BusinessDayStartHour.power);
      }

      return value;
    };
  }

  static setupPluginShowCommercialEndDate() {
    (fn as any).showCommercialEndDate = function () {
      const self = this as Moment;
      return self.clone().add(-1, 'day');
    };
  }

  static setupPluginShowCommercialMarketProduct() {
    (fn as any).showCommercialMarketProduct = function () {
      const self = this as Moment;
      return self.clone().add(-1, 'month');
    };
  }

  static setupPluginShowDateString() {
    (fn as any).showDateString = function (pattern: string = 'YYYY-MM-DD') {
      return (this as Moment).isValid() ? (this as Moment).format(pattern) : null;
    };
  }
}
